import { connect } from 'react-redux';
import AddMobileView from './views/AddMobileView';
import skipAddNumberAsyncAction from 'utils/loginAuthnTree/skipAddNumberAsyncAction';
import addBackupEmailOrNumberAsyncAction from 'utils/loginAuthnTree/addBackupEmailOrNumberAsyncActionImpl';

export const mapStateToProps = (state) => {
  const { stage, addNumberLoadingStatus, doItLaterLoadingStatus } = state.loginInfo;
  return {
    stage,
    addNumberLoadingStatus,
    doItLaterLoadingStatus,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  addNumberHandler: (payload) => dispatch(addBackupEmailOrNumberAsyncAction(payload)),
  skipAddNumberHandler: (payload) => dispatch(skipAddNumberAsyncAction(payload)),
});

const AddMobileContainer = connect(mapStateToProps, mapDispatchToProps)(AddMobileView);
export default AddMobileContainer;
